class KeyScaling {
    constructor(parameter, min=parameter.min, max=parameter.max) {
        this.parameter = parameter;
        this.min = min;
        this.max= max;
    }

    getJson() {
        return {
            min: this.min,
            max: this.max
        };
    }
}

export default KeyScaling;
